import {Select} from 'antd'
import {categories_getTopTags_api} from 'apis'
import {createValue} from 'components/form/utils'
import filterOption from 'helpers/filterOption'
import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import {useAppConfig} from 'modules/local'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo, useState} from 'react'
import CreatableSelect from 'react-select/creatable'
import {getResponseItems, NullAsDefault} from 'views/Shared'
import AntdConfigWrapper from './AntdConfigWrapper'
import {dropdownComponents, SelectWidget} from './ReactSelectComponents'
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";

export const MultiCategoryPicker = ({
                                        name,
                                        value,
                                        onChange = NullAsDefault,
                                        ...props
                                    }) => {
    const t = useTranslate()

    const {hierarchy_categories = []} = useAppConfig()

    // const options = useMemo(() => mapEntityOptions(categories), [categories])

    const defaultValue = _.isArray(value)
        ? Array.from(value).map((item) => item?.value || item)
        : []

    return (
        <AntdConfigWrapper>
            <SelectWidget
                mode="multiple"
                showSearch={true}
                value={defaultValue}
                className="w-full"
                allowClear={true}
                filterOption={filterOption}
                onChange={(value) => {
                    onChange(createValue(name, value))
                }}
                placeholder="select categories"
                {...props}>
                {hierarchy_categories.map(({name: label, idname: value, id: key, children}, index) =>
                    children ? (
                        // Có children => render như Group
                        <Select.OptGroup key={key} label={label}>
                            {children.map(({name: childLabel, idname: childValue, id: childKey}, childIndex) => (
                                <Select.Option
                                    key={childKey}
                                    value={childValue}
                                    label={childLabel}>
                                    {t(childLabel)}
                                </Select.Option>
                            ))}
                        </Select.OptGroup>
                    ) : (
                        // Không có children => render bình thường
                        <Select.Option
                            key={key}
                            value={value}
                            label={label}>
                            {t(label)}
                        </Select.Option>
                    )
                )}

            </SelectWidget>
        </AntdConfigWrapper>
    )
}

export const LookupTagsPicker = ({name, value, onChange = NullAsDefault, defaultValues = [], apiInfo = {}, ...props}) => {

    const t = useTranslate()

    const {isLoading, response, handleAsyncAction: onSearch} = useAsyncAction({
        apiInfo,
    })
    const [keyword, setKeyword] = useState();

    useEffect(() => {
        onSearch({keyword}, {})
    }, [keyword])

    const _debouncedHandleSearch = _.debounce(
        (value) => {
            setKeyword(value)
        },
        200
    )

    const options = useMemo(() => {
        let array = _.isArray(value) ? Array.from(value) : (value || "").split(",").filter(e => e);
        array = array.filter(e => !!e);
        const items = Array.from(getResponseItems(response) || []).filter(
            ({name}) => !array.includes(name)
        )
        return _.uniq([
            ...array,
            ...items.map(({name}) => name),
            ...defaultValues
        ]);
    }, [value, defaultValues, response])

    return (
        <SelectWidget
            mode="tags"
            defaultValue={_.isArray(value) ? Array.from(value) : (value || "").split(",").filter(e => e)}
            showSearch={true}
            className="w-full"
            placeholder={t('click to select')}
            allowClear={true}
            filterOption={filterOption}
            onSearch={(value) => {
                _debouncedHandleSearch(value)
            }}
            onChange={(value, ...rest) => {
                onChange(createValue(name, value))
            }}
            {...props}>
            {options.map((tag, index) => (
                <Select.Option
                    key={index}
                    value={tag}
                    label={tag}>
                    {'#' + tag}
                </Select.Option>
            ))}
        </SelectWidget>
    )
}

const TagsPicker = ({name, value, onChange = NullAsDefault}) => {
    const apiInfo = categories_getTopTags_api

    const cacheId = [apiInfo.path].join('/')

    const {response} = useAsyncWithCache({
        cacheId,
        apiInfo,
    })

    const options = useMemo(() => {
        const array = _.isArray(value) ? Array.from(value) : []
        const items = Array.from(getResponseItems(response) || []).filter(
            ({tags}) => !array.includes(tags)
        )
        return [...array, ...items.map(({tags}) => tags)]
    }, [value, response])

    return (
        <SelectWidget
            mode="tags"
            value={value}
            showSearch={true}
            className="w-full"
            allowClear={true}
            filterOption={filterOption}
            onChange={(value) => {
                onChange(createValue(name, value))
            }}>
            {options.filter(e => e).map((tag, index) => (
                <Select.Option
                    key={index}
                    value={tag}
                    label={tag}>
                    {'#' + tag}
                </Select.Option>
            ))}
        </SelectWidget>
    )
}

export const TagCreator = ({
                               createPrefix = 'add',
                               displayPrefix = '#',
                               ...props
                           }) => (
    <Translate>
        {(t) => (
            <CreatableSelect
                isMulti={true}
                noOptionsMessage={NullAsDefault}
                placeholder={
                    <span className="text-color-500 italic text-sm">
            {t('addTags1, addTags2,...')}
          </span>
                }
                formatCreateLabel={(text) => `${t(createPrefix)} "#${text}"`}
                {...props}
                styles={{
                    multiValueLabel: (styles) => {
                        return {
                            ...styles,
                            ...{
                                alignItems: 'center',
                                display: 'flex',
                                ':before': {
                                    content: `"${displayPrefix}"`,
                                    display: 'block',
                                },
                            },
                        }
                    },
                }}
                components={dropdownComponents}
            />
        )}
    </Translate>
)

export default TagsPicker
